/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_USER_LIST = gql`
  query GetUserList($input: GetUserListInput) {
    getUserList(input: $input) {
      totalCount
      data {
        email
        firstName
        lastName
        fullName
        accountStatus
        onboardingStatus
        occupation
        vuid
        nationality
        primaryContactNo
        image
        createdAt
        orgRoles {
          orgId {
            orgId
            name
          }
          role {
            name
            uuid
            state
          }
        }
      }
      currentPage
      pageSize
      totalPages
    }
  }
`;
